export interface ChipInputOption {
  token: string;
  selected: boolean;
  blocked: boolean;
  order: number | null;
}
